import { notification } from 'antd';
import type { CalendarEvent } from 'features/production-calendar/components/List/model/types';
import type {
  ProductionCalendar,
  ProductionCalendarDate,
  ProductionCalendarDateAdding,
} from './types';
import { appApi } from '../api-instance';

const MICROSERVICE_URL = '/calendar-exceptions';

export const getProductionCalendars = (): Promise<ProductionCalendar[]> => {
  return appApi
    .get(`${MICROSERVICE_URL}/tab`)
    .then((res) => res.data)
    .catch((error) => {
      notification.error({ message: 'Не удалось загрузить производственные календари' });
      throw error;
    });
};

export const getProductionCalendarYearList = (
  calendarYear: string,
): Promise<ProductionCalendarDate[]> => {
  return appApi
    .get(`${MICROSERVICE_URL}`, { params: { calendarYear } })
    .then((res) => res.data)
    .catch((error) => {
      notification.error({ message: 'Не удалось загрузить производственный календарь' });
      throw error;
    });
};

export const addProductionCalendarDate = (date: ProductionCalendarDateAdding): Promise<any> => {
  return appApi
    .post(`${MICROSERVICE_URL}`, date)
    .then((res) => res.data)
    .catch((error) => {
      notification.error({ message: 'Не удалось добавить дату в производственный календарь' });
      throw error;
    });
};

export const editProductionCalendarDate = ({ id, ...date }: CalendarEvent): Promise<void> => {
  return appApi
    .put(`${MICROSERVICE_URL}/${id}`, date)
    .then((res) => res.data)
    .catch((error) => {
      notification.error({ message: 'Не удалось обновить дату' });
      throw error;
    });
};

export const deleteProductionCalendarDate = (id: number): Promise<void> => {
  return appApi
    .delete(`${MICROSERVICE_URL}/${id}`)
    .then((res) => res.data)
    .catch((error) => {
      notification.error({ message: 'Не удалось удалить дату' });
      throw error;
    });
};
